import React from 'react';

export const IconSmallReuseLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M16.586 11.305L17.6 7.517l-1.547.894-1.352-2.341c-1.16-2.076-4.14-2.097-5.329-.038L8.456 7.62l1.77 1.022.916-1.588c.397-.687 1.453-.683 1.84.009l1.352 2.34-1.535.887 3.787 1.015zM4.742 10.58l3.787-1.014 1.015 3.787-1.535-.886-1.352 2.34c-.406.681.12 1.598.912 1.598h1.834v2.043H7.57c-2.378 0-3.85-2.591-2.632-4.634l1.352-2.34-1.547-.894zm9.049 9.658l-2.773-2.772 2.773-2.773v1.772h2.703c.793.012 1.324-.902.927-1.588l-.917-1.588 1.77-1.022.917 1.588c1.189 2.06-.32 4.63-2.697 4.597H13.79v1.786z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
